<template>
  <main id="my-invoices-main">
    <account-list :action-str-mount-chained="actionMountChained" :action-str-select-chained="actionSelectChained" :accountType="allAccounts"  :handling="true" :children="true"/>
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('invoices.list.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter" />
        </el-col>
      </el-row>

      <el-row class="historical-caption-row">
        <el-col>
            <i class="el-icon-info red-armellini"></i>&nbsp;
            <span class="font-gray info-text"> {{ $t('invoices.list.historical') }} &nbsp;</span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              class="red-link-bold"
              :href="aelis2HistoricalUrl"
            >
              {{ $t('common.here') }}
            </a>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" v-if="!invoices.isInBulkPrinting" class="default-section-title">
              {{ $t('invoices.list.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="6" v-if="invoices.isInBulkPrinting" class="default-section-title">
              <div class="single-title"> {{ $t('invoices.list.selectInvoicesToPrint') }} </div>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <print-invoice-bulk />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import AccountList from '@/components/AccountList';
import constants from '@/utils/constants';
import PrintInvoiceBulk from '@/views/customerService/components/PrintInvoiceBulk';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';

export default {
  name: 'MyInvoices',
  components: {
    AccountList,
    SearchFilter,
    SearchSummary,
    PrintInvoiceBulk
  },
  data() {
    return {
      actionMountChained: ['invoices/setMyInvoicesDefaultFilters'],
      actionSelectChained: ['invoices/searchMyInvoices', 'invoices/setIsInBulkPrinting'],
      allAccounts: constants.ACCOUNTS.TYPE[0].value
    };
  },
  computed: {
    ...mapGetters(['invoices']),
    aelis2HistoricalUrl: () => constants.AELIS2.URLS.MY_INVOICES
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
main#my-invoices-main {
  .search-summary-container {
    margin-top: 5px;
  }
}
</style>
